export default __webpack_public_path__ + "static/media/card.9feb63fa.svg";